import React from "react";
import withHOC from "../../HOC/HOC";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BasicInformation from "./BasicInformation";
import { loanUpdateAction, setBasicInformationValuesAction, updateDocRequireConfigAction, updateInvalidFormFieldAction } from "../CreateLoan/CreateLoanAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import { Row } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
import { LOAN_STEPS } from "../CreateLoan/CreateLoanConstants";
class BasicInformationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            toShowToast: false,
            successToastMessage: "",
            level: "",
        };
    }
    scrollToTop = () => {
        window.scrollTo(0, 0);
      };
    updateLoanApplcation = (basicInformationValues, callback) => {
        this.scrollToTop();
        this.props.setBasicInformationValuesAction(basicInformationValues.basicInfo);
        this.props.showLoadingModal();

        loanUpdateAction(basicInformationValues, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                let documentStatus = {
                    docRequire: response.data.data.docRequire,
                    externalInvoiceRequire: response.data.data.externalInvoiceRequire,
                    documents: response.data.data.documents,
                }
                
                this.setState({
                    toShowToast: true,
                    successToastMessage: Strings("loanFormUpdatedSuccessfully"),
                    level: "success",
                },()=>{
                    setTimeout(() => {
                        this.props.handleNext();
                        this.props.updateDocRequireConfigAction(documentStatus);
                        this.props.updateInvalidFormFieldAction(LOAN_STEPS.BASIC_INFORMATION);
                        callback("");
                        this.props.closeLoadingModal();
                    }, 1000);
                }); 
            } else {
                this.scrollToTop();
                this.props.closeLoadingModal();
                this.props.updateInvalidFormFieldAction(LOAN_STEPS.BASIC_INFORMATION);
                callback(response.error?.message);
            }
           
        });
    }
    render() {
        return (
            <Row>
                {this.state.toShowToast && (
                    <UserNotification
                        key={this.state.successToastMessage}
                        userNotificationObj={{
                            message: this.state.successToastMessage,
                            level: this.state.level,
                        }}
                    />
                )}
                <BasicInformation
                    dropdownValues={this.props.dropdownValues}
                    goNext={this.props.handleNext}
                    goBack={this.props.handleBack}
                    loanApplicationDetails={this.props.loanApplicationDetails}
                    updateLoanApplcation={this.updateLoanApplcation}
                    basicInformationDetails={this.props.basicInformationDetails}
                    showLoadingModal={this.props.showLoadingModal}
                    closeLoadingModal={this.props.closeLoadingModal}
                    loanApplicationId={this.props.applyLoanConfig.loanApplicationId}
                    minimartId={this.props.singleMiniMart.id}
                    basicInfo={this.props.basicInfo}
                    selectedLoanType={this.props.selectedLoanType}
                    disableTextField={this.props.disableTextField}
                    errorMessage={this.state.errorMessage}
                    invalidFormField={this.props.invalidFormField}
                    showLoadingModalState={this.props.showLoadingModalState}
                    scrollToTop={this.scrollToTop}
                />
            </Row>
        )
    }
}
const mapStateToProps = (state) => ({
    singleMiniMart: state.minimartListReducer.singleMiniMart,
    loanApplicationId: state.loanDetailsReducer.loanApplicationId,
    basicInformationDetails: state.loanDetailsReducer.basicInformationDetails,
    loanInfo: state.loanDetailsReducer.loanInfo,
    basicInfo: state.loanDetailsReducer.basicInfo,
    applyLoanConfig: state.loanDetailsReducer.applyLoanConfig,
    invalidFormField: state.loanDetailsReducer.invalidFormField,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setBasicInformationValuesAction,
            updateDocRequireConfigAction,
            updateInvalidFormFieldAction
        },
        dispatch
    );
};
const BasicInformationContainerWrapper = withHOC(BasicInformationContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BasicInformationContainerWrapper);